export default {
  wrongAddressFormat: 'Yanlış adres formatı',
  disconnectWallet: 'Cüzdan bağlantısını kes',
  memo: 'Not',
  stage: 'Aşama',
  tokenomics: 'Tokenomik',
  tokensPurchased: 'Satın alınan tokenlar',
  youShouldAgree: 'Şartlar ve koşulları kabul etmelisiniz',
  requiredField: 'Zorunlu alan',
  minValueIs: 'Min. değer:',
  maxValueIs: 'Maks. değer:',
  cannotCopyToClipboard: 'Panoya kopyalanamıyor',
  copiedToClipboard: 'Panoya kopyalandı',
  failed: 'İşlem başarısız oldu',
  success: 'İşlem başarılı oldu',
  aboutUs: 'Hakkımızda',
  bonuses: 'Bonuslar',
  whitepaper: 'Teknik Doküman',
  team: 'Ekip',
  community: 'Topluluk',
  checkAddress: 'Adresi kontrol et',
  currentPrice: 'GÜNCEL FİYAT',
  bonusToBase: 'TABAN FİYATINA BONUS',
  raised: 'toplandı',
  listingPrice: 'LİSTELENME FİYATI',
  scrollDownTo: 'Daha fazla bilgi edinmek için aşağı kaydırın',
  keyFeaturesOf: 'DOLLUM Cüzdanının Başlıca Özellikleri',
  essentialDollumFeatures:
    'Güvenliğiniz ve rahatınız için tasarlanan DOLLUM Cüzdanının temel özellikleri.',
  commissionOptimizer: 'Komisyon Optimize Edici',
  reduceTransactionCosts:
    'Mevcut en düşük ücretleri otomatik olarak seçerek işlem maliyetlerini azaltın.',
  emergencyStopMode: 'Acil Durdurma Modu',
  instantlyProtectAssets:
    "Acil durumlarda varlıkları USDT'ye dönüştürerek anında koruma altına alın.",
  antiHijackFeature: 'Anti-Hijack Özelliği',
  lockYourWallet:
    'Cüzdanınız tehdit altındaysa gizli acil durum sinyalini etkinleştirerek cüzdanınızı kilitleyin.',
  cryptoInvestmentPortfolio: 'Kripto Yatırım Portföyü',
  manageYourCrypto:
    'Kullanıma hazır portföylerle kripto yatırımlarınızı tek bir tıklamayla yönetin.',
  backupAddress: 'Yedek Adres',
  redirectAssetsTo:
    'Uzun süre işlem yapmadığınız dönemlerin ardından varlıklarınızı yedek bir adrese yönlendirin.',
  bonusStages: 'BONUS AŞAMALARI',
  over320Million:
    'Dünya genelinde 320 milyondan fazla kişi kripto para kullandığından güvenli kripto cüzdanlarına ve finansal çözümlere yönelik talep gün geçtikçe artıyor.',
  tokenStructure: 'TOKEN YAPISI',
  onlyEmtVill: 'ÖN SATIŞTA SADECE 210.000.000 EMT İHRAÇ EDİLECEK!',
  remainingTokens: 'Satılan Token Miktarı',
  totalRaised: 'Toplam satılan token miktarı',
  other: 'Diğer',
  is: ':',
  connectWallet: 'Cüzdanı bağla',
  operationInProgress: 'İşlem devam ediyor',
  pleaseWait: 'Lütfen bekleyin',
  buying: 'Satın alma',
  for: 'kimin için:',
  confirmThisTransaction: 'Bu işlemi cüzdanınızda onaylayın',
  changeMetamaskWallet: 'Metamask Cüzdanını Değiştir',
  connectedWith: 'Şuna bağlı:',
  copyAddress: 'Adresi Kopyala',
  viewOnExplorer: "Gezgin'de Görüntüle",
  checkAddressText:
    'Tokenlarımızı satın almada kullandığınız cüzdan adresini girerek tokenların miktarını ve durumunu görüntüleyebilirsiniz.',
  frozenFor: 'Kilitleme süresi: ',
  month: 'ay',
  months: 'ay',
  scheduleOfThe: 'Fon kilit açma programı',
  back: 'GERİ',
  available: 'Mevcut',
  buy: 'Satın Al',
  enterTheWallet: 'DOLLUM tokenını almak istediğiniz adresi girin.',
  addressMustBe: 'Tokenlerinizi güvenle almak için yalnızca BSC ağını kullanın',
  youAreAt: 'Şu anda bulunduğunuz adım:',
  of: '/',
  notUseExchangeWallets:
    'Sadece DeFi cüzdanlarını kullanın (ör. MetaMask, Trust Wallet, Coinbase Wallet). Borsa cüzdanlarını kullanmayın',
  continue: 'Devam',
  youAreOnLast: 'Son adımdasınız',
  youMustTransfer: 'Şu miktarda fon transfer etmeniz gerekiyor:',
  address: 'Adres',
  thisOperationTakes: 'İşlemin tamamlanması 3 saate kadar sürer',
  update: 'Güncelle',
  copyTransactionHash: 'İşlem hash kodunu kopyala',
  copy: 'Kopyala',
  depositTheSpecified: 'Belirtilen fonları bu cüzdana yatır',
  balance: 'Bakiye',
  receive: 'Al',
  theOperationSuccessful: 'İşlem başarılı',
  yourFundsWill: 'Fonlarınız cüzdanınıza aktarılacaktır',
  afterTheCompletion:
    'Tüm ön satış turları tamamlandıktan sonra DOL tokenı kilit açma süreci başlayacaktır',
  theAmountOf: 'Miktarı',
  setOneText1: "2023'te 1,5 milyar USD'lik kripto cüzdan piyasa değeri",
  setOneText2: "Piyasa gelirinin %40'ı kripto ticaretinden kaynaklanıyor",
  setOneText3: 'Önümüzdeki on yılda kripto ile ödemelerde %50 büyüme',
  setTwoText1:
    "Kullanıcıların %70'i staking ve DeFi entegrasyonunu tercih ediyor",
  setTwoText2: 'Token satışlarından 175 milyon USD tutarında potansiyel gelir',
  setTwoText3: "Toplam arzın %10'u pazarlama girişimleri için ayrıldı",
  metric: 'Metrik',
  currentMarketState: 'Mevcut Piyasa Durumu',
  forecastedGrowth: 'Tahmini Büyüme',
  userSegments: 'Kullanıcı Segmentleri',
  opportunitiesForDollum: 'DOLLUM Cüzdanı ile İlgili Fırsatlar',
  marketValue: 'Piyasa Değeri',
  retailInvestorsFinancial: 'Bireysel yatırımcılar, finansal kurumlar',
  increasingDemandFor: 'Kripto cüzdanlarına yönelik artan talep',
  numberOfCrypto: 'Kripto Kullanıcı Sayısı',
  expectedToReach: '2030 yılına kadar 500+ milyona ulaşması bekleniyor',
  youthEntrepreneursInstitutional: 'Gençler, girişimciler, kurumsal müşteriler',
  attractNewUsers: 'DeFi aracılığıyla yeni kullanıcı edinimi',
  mobileWalletShare: 'Mobil Cüzdan Payı',
  belongsToAndroid: "Piyasanın %45'i Android'e ait",
  mobileSolutionsExpected: 'Mobil çözümlerin yıllık %10 büyümesi bekleniyor',
  smartphoneUsers: 'Akıllı telefon kullanıcıları',
  convenienceAndMobile: 'Kolaylık ve mobil erişim',
  defiAndStacking: 'DeFi ve Staking',
  integrationWithDefi: 'DeFi protokolleri ile entegrasyon',
  exponentialGrowthIn: 'DeFi hizmetlerine yönelik talepte üstsel artış',
  activeCryptoInvestors: 'Aktif kripto yatırımcıları',
  directAccessTo: "Staking ve DEX'e doğrudan erişim",
  marketRegions: 'Piyasa Bölgeleri',
  marketLeaders: 'Piyasa liderleri: Kuzey Amerika, Asya',
  asiaAndLatin: 'Asya ve Latin Amerika - en çok umut vaat eden bölgeler',
  entrepreneursAndLow: 'Girişimciler ve düşük gelirli kullanıcılar',
  expansionIntoNew: 'Yeni pazarlara açılma',
  millionCryptoUsers: 'milyon kripto kullanıcısı (dünya genelinde)',
  allocationOfFunds: 'FONLARIN TAHSİSİ',
  seedRound: 'Seed turu',
  round: 'tur',
  Round: 'Tur',
  tokenPrice: 'Token fiyatı',
  privateRound: 'Özel satış turu',
  presaleRound: 'Ön satış turu',
  publicSaleRound: 'Halka açık satış turu',
  marketingCommunityBuilding: 'Pazarlama, Topluluk oluşturma, Airdrop',
  teamAndFounders: 'Ekip ve Kurucular',
  ecosystemDevelopmentFund: 'Ekosistem Geliştirme Fonu',
  liquidityFund: 'Likidite Fonu',
  stakingRewards: 'Staking ödülleri',
  reserveFund: 'Rezerv Fon',
  usersChooseStaking: "Kullanıcıların %70'i DOLLUM'da staking'i seçiyor",
  theMajorityOf:
    'DOLLUM Cüzdanı kullanıcılarının çoğu, istikrarlı bir gelir elde etmek ve DeFi ekosisteminin büyümesine katılmak için aktif olarak staking yaparak yüksek APY ve cüzdan güvenliğinden faydalanıyor.',
  preliminaryEstimateBased:
    '**Mevcut piyasa trendlerine dayalı bir ön tahmindir.',
  roadmapText1: 'Gözetimsiz cüzdan',
  roadmapText1Part2: 'Temel gözetim özellikleri',
  roadmapText1Part3: 'Teknik Doküman',
  roadmapText2: 'Gözetimsiz cüzdan',
  roadmapText2Part2: 'Temel gözetim özellikleri ',
  roadmapText2Part3: 'Teknik Doküman ',
  roadmapText3: 'Anti-hijack',
  roadmapText3Part2: 'Cüzdan Lansmanı ',
  roadmapText3Part3: 'Yedek adres özelliği',
  roadmapText3Part4: 'Acil transfer ',
  roadmapText3Part5: 'Portföy yöneticisi',
  roadmapText4: 'Tokenomik ve Token satışı',
  roadmapText4Part2: 'Komisyon optimize edici',
  roadmapText4Part3: 'İşlem içi mesajlar',
  roadmapText5: 'Cüzdan içinde NFT',
  roadmapText5Part2: 'İtibari para ile kripto satın al',
  roadmapText5Part3: 'Gözetimsiz cüzdan özelliğini kullanarak takas yap',
  roadmapText6: 'Halka Açık Beta',
  roadmapText6Part2:
    'DOL tokenını dolar standardına dayalı bir varlık olarak entegre etmeye yönelik küresel bankacılık kurumlarıyla stratejik ittifaklar.',
  roadmapText6Part3: 'Banka kartları',
  roadmapText6Part4: 'Kripto Borsalarında Listeleme',
  roadmapText6Part5: 'Dollum kripto borsası beta',
  roadmapText7: 'Cüzdan Lansmanı',
  roadmapText7Part2:
    'DOL tokenının devlet öncülüğündeki girişimlerde dijital bir araç olarak benimsenmesi.',
  roadmapText7Part3: 'Dollum blok zinciri',
  roadmapText7Part4: 'NFT Pazaryeri beta',
  roadmapText8: 'Kripto borsa lansmanı',
  roadmapText8Part2: 'NFT Pazaryeri lansmanı',
  tokenRoadmap: 'Token Yol Haritası',
  roadmap: 'Yol Haritası',
  competitorComparison: 'Rakip Karşılaştırması',
  featureAttribute: 'Özellik/Öznitelik',
  typeOfWallet: 'Cüzdan Türü',
  custodialNonCustodial: 'Gözetimli ve Gözetimsiz',
  nonCustodial: 'Gözetimsiz',
  cryptocurrenciesSupported: 'Desteklenen Kripto Para Birimleri',
  bitcoinEthereumTron: 'Bitcoin, Ethereum, Tron, Polygon ve daha fazlası',
  thousandCoins: "1.000'den fazla coin",
  ethereumTokens: 'Ethereum, ERC-20 tokenları',
  assets130: "130'dan fazla varlık",
  assets500: "500'dan fazla varlık",
  supportedPlatforms: 'Desteklenen Platformlar',
  defiIntegration: 'DeFi Entegrasyonu',
  yes: 'Evet',
  stakingSupport: 'Staking Desteği',
  no: 'Hayır',
  tokenSwapping: 'Token Takası',
  yesNativeExternal: 'Evet (yerel ve harici)',
  securityFeatures: 'Güvenlik Özellikleri',
  biometricPassword: 'Biyometrik, Parola',
  passwordPrivateKey: 'Parola, Özel Anahtar',
  biometric2Fa: 'Biyometrik, 2FA',
  kycCompliance: 'KYC/AML Uyumluluğu',
  yesForCustodial: 'Evet (gözetimli cüzdan için)',
  backupRecovery: 'Yedekleme ve Kurtarma',
  yesSeedPhrases: 'Evet (seed ifadeleri, 2FA)',
  yesSeedPhrase: 'Evet (seed ifadesi)',
  supportedBlockchains: 'Desteklenen Blok Zincirler',
  multiBlockChainCustom: 'Çoklu blok zincir (özelleştirilebilir)',
  multiBlockchain: 'Çoklu blok zincir',
  userInterface: 'Kullanıcı Arayüzü',
  intuitiveCustomizable: 'Sezgisel, özelleştirilebilir (koyu/açık tema)',
  simpleCleanInterface: 'Basit, sade arayüz',
  simpleDeveloperFocused: 'Basit, geliştirici odaklı',
  cleanAndUser: 'Sade ve kullanıcı dostu',
  visualAppealing: 'Görsel olarak çekici, özelleştirilebilir',
  cleanSimple: 'Sade, basit',
  crossChainSwapping: 'Zincirler Arası Takas',
  fees: 'Ücretler',
  adjustableOptimizedUsing:
    'Ayarlanabilir, Komisyon Optimize Edici kullanılarak optimize edilmiştir',
  adjustable: 'Ayarlanabilir',
  fixedForCustodial:
    'Gözetimli cüzdan için sabit; gözetimsiz cüzdan için ayarlanabilir',
  backupAddressFeature: 'Yedek Adres Özelliği',
  yesNonCustodial: 'Evet (gözetimsiz)',
  pushNotifications: 'Anlık Bildirimler',
  hardwareWalletSupport: 'Donanım Cüzdanı Desteği',
  yesViaTrezor: 'Evet (Trezor aracılığıyla)',
  yesLedgerTrezor: 'Evet (Ledger/Trezor)',
  yesTrezor: 'Evet (Trezor)',
  yesLedger: 'Evet (Ledger)',
  nftSupport: 'NFT Desteği',
  feeOptimization: 'Ücret Optimizasyonu',
  yesCommissionOptimizer: 'Evet (Komisyon Optimize Edici)',
  twoFactorAuth: 'İki Faktörlü Kimlik Doğrulaması (2FA)',
  fiatConversion: 'İtibari Para Dönüşümü',
  yesCustodialOnly: 'Evet (sadece gözetimli)',
  mobileSpecificFeatures: 'Mobile Özgü Özellikler',
  storiesEmergencyStop: 'Hikayeler, Acil Durdurma, Anti-Hijack',
  none: 'Yok',
  adminPanel: 'Yönetici Paneli',
  yesCustodialService: 'Evet (gözetim hizmeti için)',
  nativeDexAddress: 'Yerel DEX Erişimi',
  decentralizedAppBrowser: 'Merkezi Olmayan Uygulama Tarayıcısı',
  biometricLogin: 'Biyometrik Giriş',
  reputationSystem: 'İtibar Sistemi',
  yesInternalWallet: 'Evet (dahili cüzdan derecelendirmesi)',
  additionalSecurityTools: 'Ek Güvenlik Araçları',
  emergencyStopAnti: 'Acil Durdurma, Anti-Hijack',
  languagesSupport: 'Desteklenen Diller',
  multiLanguageSupport: 'Çoklu dil desteği',
  english: 'İngilizce',
  customerSupport: 'Müşteri Desteği',
  yesBuildIt: 'Evet (yerleşik destek seçenekleri)',
  yesHelpCenter: 'Evet (yardım merkezi)',
  yes24Support: 'Evet (7/24 destek)',
  yesInApp: 'Evet (uygulama içi destek)',
  frequentlyAskedQuestions: 'SIKÇA SORULAN SORULAR',
  howFindFrequently:
    'Burada ürünümüzle ilgili sıkça sorulan tüm soruları bulabilirsiniz',
  faqTitle1: "DOLLUM Cüzdanı'nda nasıl cüzdan oluştururum?",
  faqTitle2: 'DOLLUM Cüzdanı hangi ücretlere tabi?',
  faqTitle3: 'Cüzdan, DeFi entegrasyonunu destekliyor mu?',
  faqTitle4: 'Acil Durdurma özelliğini nasıl kullanırım?',
  faqTitle5: 'DOLLUM Cüzdanı, NFT depolamak için kullanılabilir mi?',
  faqTitle6: 'Cihazım kaybolursa cüzdan erişimimi nasıl kurtarırım?',
  faqText1:
    'Cüzdan oluşturmak için uygulamayı indirin, kayıt işlemini tamamlayın, cüzdan türünü seçin (gözetimli/gözetimsiz) ve erişim için seed ifadenizi güvenli bir yerde saklayın.',
  faqText2:
    'DOLLUM Cüzdanı, mevcut en düşük oranları seçerek işlem ücretlerini otomatik olarak optimize eder ve böylece işlemler sırasında kullanıcı maliyetlerini en aza indirir.',
  faqText3:
    "Evet. DOLLUM Cüzdanı, DeFi protokollerini tamamen destekleyerek entegre DEX'ler aracılığıyla kullanıcıların staking, farming ve token takaslarına katılmalarına olanak sağlar.",
  faqText4:
    "Acil Durdurma özelliği, güvenlik tehdit altındaysa varlıkları anında stablecoin'lere dönüştürür veya cüzdanı kilitler. Bu özellik, cüzdanın ayarlarından etkinleştirilebilir.",
  faqText5:
    "Evet. DOLLUM Cüzdanı NFT'lerin depolanmasını, görüntülenmesini ve alınıp satılmasını destekleyerek kullanıcıların dijital koleksiyonlarını doğrudan cüzdan içinde güvenli bir şekilde yönetmelerine olanak tanır.",
  faqText6:
    'Cüzdan oluşturma işlemi sırasında sağlanan seed ifadesini kullanarak cüzdanınıza tekrar erişim elde edebilirsiniz. Seed ifadesini güvenli bir yerde sakladığınızdan emin olun.',
  footerReservedText:
    'Web sitesi, Seyşeller Cumhuriyeti yasalarına göre kurulmuş olan ve kayıtlı iş yeri adresi Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seyşeller olan SecureLabs LTd tarafından işletilmektedir. Tüm hakları saklıdır',
  termsOfUse: 'Kullanım koşulları',
  privacyPolicy: 'Gizlilik Politikası',
  cookiePreferences: 'Çerez Tercihleri',
  agreeToTransaction:
    'İşlemi ve ayrıca şu belgelerde yer alan hükümleri kabul ediyorum: ',
  and: 've',
  termsAndConditions: 'Şartlar ve Koşullar',
  alsoYouCan: 'Ayrıca tahsisatınızın onayını şurada doğrulayabilirsiniz: ',
  usingTheTransaction:
    '(işlem hash kodunu kullanarak). Alıcı adresi belirterek DOL tokenlarınızın detaylı kilit açma programını bu sitede istediğiniz zaman görüntüleyebilirsiniz.',
  followUsOn: 'Bizi sosyal medyada takip edin',
  lockedFor: 'Şu süre boyunca kilitli:',
  selectNetwork: 'Ağ seçin',
  dolTokenWill: "DOL Tokenı, Binance Smart Chain Network'te lanse edilecektir",
  copyTxHash: 'İşlem hash kodunu kopyala',
  theOperationExpired: 'İşlem süresi doldu',
  waitingTimeHas: 'Bekleme süresi doldu, tekrar deneyin',
  ifTheProblem: 'Sorun tekrarlanırsa lütfen ',
  sendUsEmail: 'e-posta yoluyla bize ulaşın',
  contactSupport: 'destek ekibiyle iletişime geçin',
  tryAgain: 'Tekrar dene',
  theOperationFailed: 'İşlem başarısız oldu',
  error: 'Hata',
  tokenUnlockingSchedule: 'Token Kilit Açma Programı:',
  promoCodeUsed: 'Promosyon kodu başarıyla kullanıldı',
  congratulations: 'Tebrikler',
  youCanActivate: 'Şuna ait promosyon kodunu etkinleştirebilirsiniz: ',
  activateYourPromocode: 'Promosyon kodunuzu etkinleştirin',
  getting: 'Alınıyor',
  totalRaisedInUsd: 'Toplam toplanan',
  nextStage: 'Sonraki aşama',
  pay: 'Öde',
  info: 'Bilgi',
  dollumApp: 'Dollum Uygulaması',
  trustApp: 'Trust Uygulaması',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase Uygulaması',
  exodusApp: 'Exodus Uygulaması',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: "2023'te 1,5 milyar USD",
  bonusRowsGrowth1: "2023'te 1,5 milyar USD",
  bonusRowsState2: '320 milyondan fazla kripto kullanıcısı',
  multiformatSupport: 'Bitcoin, Ethereum, ERC-20',
  iosAndroidDesktopLightVersion: 'iOS, Android, Masaüstü (Hafif Sürüm)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Tarayıcı',
  iosAndroidDesktop: 'iOS, Android, Masaüstü',
  biometricPin2Fa:
    'Biyometrik, PIN, 2FA, SSL sabitleme, AES-256 şifreleme, "Acil Durdurma", "Anti-Hijack"',
  ethereum: 'Ethereum',

  poweredBy: 'Tarafından desteklenmektedir',
  live: 'Canlı',
  auditAndKycVerified: 'Denetim & KYC Doğrulandı',
  teamKycVerification: 'Ekip KYC Doğrulaması',
  smartContractAudit: 'Akıllı Sözleşme Denetimi',
  securityComesFirst: 'Güvenlik her şeyden önce gelir.',
  ourSmartContractHasBeenFullyAudited: 'Akıllı sözleşmemiz tamamen denetlendi',
  bySolidProof: 'SolidProof tarafından,',
  oneOfTheLeadingBlockchainAuditFirms:
    'önde gelen blok zinciri denetim firmalarından biri.',
  additionally: 'Ayrıca,',
  dollumTeamCompletedKYC: 'Dollum ekibi KYC doğrulamasını başarıyla tamamladı',
  ensuringTransparencyAndAccountability:
    ', topluluğumuz için şeffaflık ve hesap verebilirlik sağlar.',
  servicesAndCertificates: 'Hizmetler & Sertifikalar',
  kyc: 'KYC',
  securityScore: 'Güvenlik Puanı',
  poor: 'Zayıf',
  excellent: 'Mükemmel',
  writesMediaAboutUs: 'Hakkımızda yazan medya',

  stageTwoAlmostSold: '2. Aşama neredeyse tükendi — Sonraki fiyat: $0.20',
  buyBeforeThePriceIncreases: 'Fiyat artmadan şimdi $0.15’e satın alın!',

  useOnlyDefiWallet:
    'Yalnızca MetaMask, Trust Wallet veya Coinbase Wallet gibi bir DeFi cüzdanı kullanın.',
  makeSureYourWalletIsConnectedToTheBsc:
    'Cüzdanınızın BSC (Binance Smart Chain) ağına bağlı olduğundan emin olun.',
  copyYourBscWalletAddress:
    'BSC cüzdan adresinizi (0x ile başlar) kopyalayın ve alana yapıştırın.',
  doNotUseExchangeWallets:
    'Borsa cüzdanlarını kullanmayın (örneğin Binance, KuCoin veya OKX).',

  needHelp: 'Yardım mı lazım?',

  stage3IsSellingFast: 'Son Ön Satış Aşaması — Listelemeden Önceki Son Şans',
  nextStagePriceIncreases:
    'Planlanan $1.00 başlangıç listeleme fiyatından önce tokenlarınızı şimdi güvence altına alın',
  finalPresaleStage: 'Son Ön Satış Aşaması',

  weAreLive: 'Yayındayız!',
  weWillLiveSoon: 'Yakında yayında olacağız',
  startManagingYourCryptoSecurely: 'Kriptonuzu güvenle yönetmeye başlayın',

  launchpadIntroduction: 'Launchpad Tanıtımı',
  continuedPlatformDevelopment:
    'Platformun sürekli geliştirilmesi ve ekosistemin genişletilmesi',
  expansionIntoIntegratedFinancialServices:
    'Ödeme ve borçlanma dahil olmak üzere entegre finansal hizmetlere genişleme',
  ecosystemScaling:
    'Ekosistemin ölçeklendirilmesi ve özelliklerin genişletilmesi',
  platformOptimizationAndInfrastructure:
    'Platform optimizasyonu ve altyapının güçlendirilmesi',
  platformForBroaderMarketIntegration:
    'Daha geniş pazar entegrasyonu için hazırlık',
  structuredDigitalFinanceEcosystem:
    'YAPILANDIRILMIŞ BİR DİJİTAL FİNANS EKOSİSTEMİ',
  dollumCombinesSecureWallet:
    'Dollum, güvenli cüzdan altyapısını, staking’i ve entegre finansal araçları tek bir platformda birleştirir — ödeme ve borçlanma yeteneklerine doğru genişler.',
  finalStageLimitedAllocationRemaining: 'Son aşama — sınırlı tahsis kaldı',
  nowAvailable: 'Artık mevcut',
  digitalAssetManagement:
    'Entegre ödeme özelliklerine sahip dijital varlık yönetimi',
};
